export class Token {
  UserId: string = '';
  SessionId: number = 0;
  TokenId: string = '';
  GroupId: string = '';
  DefaultWarehouseCode: string = '';
  DefaultOwnerCode: string = '';
  DefaultEntityCode: string = '';
  DefaultDivisionCode: string = '';
  DefaultDepartmentCode: string = '';
  Language: string = '';
  DateFormat: number = 0;
  DateFormatDescription: string = '';
  TimeFormatDescription: string = '';
  DateTimeFormatDescription: string = '';
  Timeout: number = 0;
  LoginTime: string = '';
}



// WEBPACK FOOTER //
// ./src/app/data/models/base/token.ts